import NotFound from '../components/NotFound/NotFound.js';
import Page from '../components/Page/Page.js';

function NotFoundPage()
{
    return(
        <Page mainSection={<NotFound />} />
    );
}

export default NotFoundPage;